import React from 'react';

import { LoadableLazy } from '@confluence/loadable';
import { ErrorDisplay } from '@confluence/error-boundary/entry-points/ErrorDisplay';
import { Attribution } from '@confluence/error-boundary/entry-points/Attribution';
import { withTransparentErrorBoundary } from '@confluence/error-boundary/entry-points/withErrorBoundary';

import { useRovoAnnouncementSplashModal } from './hooks/useRovoAnnouncementSplashModal';

export const RovoAnnouncementSplashModalWrapper = withTransparentErrorBoundary({
	attribution: Attribution.FLYWHEEL_FEATURE_DISCOVERY,
})(() => {
	const { isModalVisible, onModalShown, loading, error } = useRovoAnnouncementSplashModal();

	if (error) {
		return <ErrorDisplay error={error} />;
	}

	if (loading || !isModalVisible) {
		return null;
	}

	return <LazyModal onModalShown={onModalShown} />;
});

const LazyModal = LoadableLazy({
	loader: async () =>
		(
			await import(
				/* webpackChunkName: "loadable-rovo-announcement-splash-modal" */ '../src/modal-from-scratch/RovoAnnouncementSplashModalFromScratch'
			)
		).RovoAnnouncementSplashModalFromScratch,
});
